import { watch } from "vue";
import { useAuthStore } from "./auth-store";

interface WebsiteAuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  hasCheckedAuth: boolean;
  user: { id: string; email: string } | null;
  error: string | null;
}

/** Mirror the owning Pinia instance, including hidden Vue trees on native routes. */
export function syncVueAuthToReact(source: WebsiteAuthState): () => void {
  return watch(
    () => [
      source.isAuthenticated,
      source.isLoading,
      source.hasCheckedAuth,
      source.user?.id,
      source.user?.email,
      source.error,
    ],
    () => {
      useAuthStore.setState({
        isAuthenticated: source.isAuthenticated,
        isLoading: !source.hasCheckedAuth || source.isLoading,
        user: source.user
          ? { id: source.user.id, email: source.user.email }
          : null,
        error: source.error,
      });
    },
    { immediate: true }
  );
}
